import { Avatar } from "@components/ui/Avatar"
import type { ReactNode } from "react"
import { Link } from "react-router-dom"

/** Who the row is: initials, name, and the address they sign in with. */
export function PersonIdentity({
  name,
  email,
  badge,
  to,
  state,
}: {
  name: string
  email: string
  /** A short tag after the name ("Tú"). */
  badge?: ReactNode
  /** The person's page (PRD-56 PR (4)): the name becomes the link to it. */
  to?: string
  /** Travels with the link — where the page's "back" should lead. */
  state?: unknown
}) {
  return (
    <span className="flex min-w-0 items-center gap-3">
      <Avatar name={name} />
      <span className="min-w-0">
        <span className="flex items-center gap-2">
          {to ? (
            <Link
              to={to}
              state={state}
              className="text-ink truncate font-medium underline-offset-2 hover:underline"
            >
              {name}
            </Link>
          ) : (
            <span className="text-ink truncate font-medium">{name}</span>
          )}
          {badge}
        </span>
        <span className="text-meta block truncate">{email}</span>
      </span>
    </span>
  )
}
